import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { DialogContent, withMobileDialog, DialogTitle } from '@material-ui/core';
import { sendBoostMessage } from '../../utils/ws-v1';
import { getSocketIfExist } from '../../utils/getSocket';
const onDelete = (word) => {
    const ws = getSocketIfExist();
    sendBoostMessage(ws, {
        action: 'remove',
        word,
    });
};
const onCreate = (word) => {
    if (word.length) {
        const ws = getSocketIfExist();
        sendBoostMessage(ws, {
            action: 'add',
            word,
        });
    }
};
// eslint-disable-next-line
class BoostModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { boost: '' };
    }
    render() {
        const { updateBoosting, open, fullScreen, boostList } = this.props;
        const { boost } = this.state;
        return (React.createElement(Dialog, { open: open, fullScreen: fullScreen },
            React.createElement(DialogContent, null,
                React.createElement(DialogTitle, { variant: "h5", style: { alignSelf: 'center' } }, "Boost")),
            React.createElement("div", null,
                React.createElement("div", { className: "row inputs" },
                    React.createElement("div", { className: "col-lg-7" },
                        React.createElement("input", { type: "text", name: "band", placeholder: "boost", onChange: (e) => this.setState({ boost: e.target.value }), value: boost, className: "form-control", size: "20" })),
                    React.createElement("div", { className: "col-md-3" },
                        React.createElement("button", { type: "button", style: { width: '100%' }, className: "btn btn-success", onClick: () => {
                                onCreate(boost);
                            } }, "Add"))),
                React.createElement("table", { className: "table" },
                    React.createElement("tbody", null, boostList.map((data) => {
                        return (React.createElement("tr", null,
                            React.createElement("td", { style: { width: '30%' } }, data),
                            React.createElement("td", { style: { width: '10%' } },
                                React.createElement("button", { type: "button", className: "btn btn-danger", onClick: () => onDelete(data) }, "Delete"))));
                    })))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { type: "submit", onClick: () => {
                        updateBoosting(false);
                    }, color: "secondary" }, "Quit"))));
    }
}
export default withMobileDialog({ breakpoint: 'xs' })(BoostModal);
